module.exports = __webpack_public_path__ + "fin-trauma.gif?64fd75bff72762b48863db4df631401e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fin-trauma.gif
// module id = 169
// module chunks = 0